export default "__VITE_ASSET__0c245fcb__"